// extracted by mini-css-extract-plugin
export default {"nftCommentInput":"juzySm3hBNz_X32lK0kv"};